import styled from '@emotion/styled';
import { useSetAtom } from 'jotai';
import { useEffect, useId } from 'react';
import Lower from './Lower';
import NoticeBanner from './NoticeBanner';
import Upper from './Upper';
import Divider from '@/components/comm/Divider';
import { useIsShowMobileNav, mobileNavIdAtom } from '@/components/layout/gnb/MobileNav';
import { colors } from '@/constants/colors';

const Header = styled.header<{ sticky: boolean }>`
z-index: 1;
display: grid;
border-bottom: 1px solid ${colors.brightGrey3};
background-color: ${colors.white};
grid-template-columns: 100%;
justify-items: center;
overflow-x: hidden;

${({ sticky }) => sticky && `
  position: sticky;
  top: 0;
`}
`;

const MobileNavDiv = styled.div`
width: 100%;
`;

const Gnb = () => {
  const mobileNavId = useId();
  const setMobileNavId = useSetAtom(mobileNavIdAtom);
  const isShowMobileNav = useIsShowMobileNav();

  useEffect(() => {
    setMobileNavId(mobileNavId);
  }, [mobileNavId, setMobileNavId]);

  return (
    <>
      <NoticeBanner />
      <Header sticky={isShowMobileNav}>
        <MobileNavDiv id={mobileNavId} />
        {!isShowMobileNav && (
          <>
            <Upper />
            <Divider color={colors.brightGrey3} />
            <Lower />
          </>
        )}
      </Header>
    </>
  );
};

export default Gnb;
